module.exports = require('./src/isomorphic-mongo-objectid.js');
